import { takeEvery, call, put } from 'redux-saga/effects';
import { yaGoal } from 'mt-react-common/utils/Analytics';

import {
  sendRequest,
  requestInProcess,
  requestFinished,
  initState
} from '../../../../common/reducers/execRefuseForm';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsService from '../../../../services/TasksExecsService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { dataRequest } from '../../../../../../common/reducers/objectCollection/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';

function* execRefuseSaga(reducerName, action) {
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      TasksExecsService.sendRefuse,
      action.payload
    );
    if (result) {
      if (result.status === 200) {
        yield put(initState(reducerName));
        yield put(sendGetAuthAccountDataRequest());
        yield put(
          dataRequest(
            'tasksModule.collections.tasksExecsCollection',
            action.payload
          )
        );
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: result.data.message
          })
        );
        yaGoal('refuseTaskExec');
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
  yield put(requestFinished(reducerName));
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, execRefuseSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskExecExecutorForms/saga/execRefuseSaga.js